import { FC, useState } from 'react';

import IntroInterests from './intro-interests/intro-interests';
import SelectInterestsContainer from './select-interests-container';

type Props = {
  onSkip: () => void;
  skipIntro?: boolean;
};

const InterestsContainer: FC<Props> = ({ onSkip, skipIntro }: Props) => {
  const [showInterests, setShowInterests] = useState(!!skipIntro);

  return (
    <section>
      {!showInterests ? (
        <IntroInterests
          onSkip={onSkip}
          onSetInterests={() => setShowInterests(true)}
        />
      ) : (
        <SelectInterestsContainer onFinish={onSkip} />
      )}
    </section>
  );
};

export default InterestsContainer;
